module.exports = "/_next/static/images/img__notice_touch-817cce97af25792672b2941e29ca9476.png";